<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED">IN MEMORY OF MY MOTHER,</p>
<p class="DED">JOAN JARVIS (NÉE STORY),</p>
<p class="DED">WHO DIED ON <span class="non-aligning-figs-regular">18</span> FEBRUARY <span class="non-aligning-figs-regular">2004</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?626d6e88